import {MST_TAXGROUP_ENDPOINT} from '../../constants/endpoints'
import {PaginateModel} from '../../models/PaginateModel'
import axios from 'axios'
import {ResponseModel} from '../../models/ResponseModel'
import { MstTaxGroupModel, SearchModel } from '../../models/MstTaxGroupModel'

export function getList(params?: SearchModel) {
  return axios.get<PaginateModel<MstTaxGroupModel>>(`${MST_TAXGROUP_ENDPOINT}`, {params})
}

export function store(taxGroup: MstTaxGroupModel) {
  return axios.post<ResponseModel>(MST_TAXGROUP_ENDPOINT, taxGroup)
}

export function update(taxGroup: MstTaxGroupModel) {
  return axios.post<ResponseModel>(MST_TAXGROUP_ENDPOINT, taxGroup)
}

export function remove(ids?: number[]) {
  return axios.delete<ResponseModel>(`${MST_TAXGROUP_ENDPOINT}/destroy`, {params: {ids}})
}
